// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadAndSearchMarks_container__9Hus9 {
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  color: #333;
}
.UploadAndSearchMarks_title__KqudK {
  text-align: center;
  margin-bottom: 20px;
  color: #005f99;
}
.UploadAndSearchMarks_section__ap05U {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.UploadAndSearchMarks_subtitle__YNqcy {
  margin-right: auto;
  color: #005f99;
}
.UploadAndSearchMarks_fileInput__LKf7w, .UploadAndSearchMarks_dateInput__i2KTK {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.UploadAndSearchMarks_button__KHWdg {
  padding: 8px 16px;
  background-color: #007acc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}
.UploadAndSearchMarks_button__KHWdg:disabled {
  background-color: #aaccea;
  cursor: default;
}
.UploadAndSearchMarks_button__KHWdg:hover:enabled {
  background-color: #005fa3;
}
.UploadAndSearchMarks_message__u1qkR {
  text-align: center;
  color: #c00;
  margin: 10px 0;
}
.UploadAndSearchMarks_resultsSection__EhMfR {
  margin-bottom: 20px;
}
.UploadAndSearchMarks_noResults__jY3YR {
  text-align: center;
  color: #666;
}
.UploadAndSearchMarks_grid__rIWkk {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 15px;
}
.UploadAndSearchMarks_card__WjJhr {
  background: white;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.1s;
}
.UploadAndSearchMarks_card__WjJhr:hover {
  transform: translateY(-2px);
}
.UploadAndSearchMarks_serial__cF69l {
  font-weight: bold;
  margin-bottom: 6px;
}
.UploadAndSearchMarks_barcode__SA6-V {
  display: block;
  margin: 0 auto 6px;
  width: 100%;
}
.UploadAndSearchMarks_info__cfqTK {
  font-size: 14px;
  text-align: center;
}
.UploadAndSearchMarks_pagination__VXQs9 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.UploadAndSearchMarks_pageButton__ZgqzJ {
  padding: 6px 12px;
  background: #007acc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.UploadAndSearchMarks_pageButton__ZgqzJ:disabled {
  background: #aaccea;
  cursor: default;
}
.UploadAndSearchMarks_pageInfo__AefN7 {
  font-size: 14px;
}
.UploadAndSearchMarks_backdrop__oNaqo {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.UploadAndSearchMarks_modal__0Ozu0 {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 80%;
}
.UploadAndSearchMarks_pre__omEci {
  background: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  max-height: 300px;
  overflow: auto;
}

.UploadAndSearchMarks_buttonSecondary__K-zY- {
  padding: 6px 12px;
  background: #eee;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}
.UploadAndSearchMarks_buttonSecondary__K-zY-:hover {
  background: #ddd;
}
.UploadAndSearchMarks_fieldGroup__2vseD {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.UploadAndSearchMarks_label__lNsPn {
  min-width: 80px;
}
.UploadAndSearchMarks_fileInput__LKf7w {
  flex: 1 1;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

/* правим позиционирование бейджа внутри карточки */
.UploadAndSearchMarks_routeListBadge__cpoZB {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #007bff;
  color: #fff;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 4px;
}
.UploadAndSearchMarks_card__WjJhr {
  position: relative; /* чтобы absolute внутри работал */
  /* ... остальные стили ... */
}`, "",{"version":3,"sources":["webpack://./src/modules/Developer/TestPages/Marks/UploadAndSearchMarks.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB,EAAE,kCAAkC;EACtD,4BAA4B;AAC9B","sourcesContent":[".container {\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  font-family: 'Arial', sans-serif;\r\n  color: #333;\r\n}\r\n.title {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  color: #005f99;\r\n}\r\n.section {\r\n  background: #f9f9f9;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n.subtitle {\r\n  margin-right: auto;\r\n  color: #005f99;\r\n}\r\n.fileInput, .dateInput {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n.button {\r\n  padding: 8px 16px;\r\n  background-color: #007acc;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n.button:disabled {\r\n  background-color: #aaccea;\r\n  cursor: default;\r\n}\r\n.button:hover:enabled {\r\n  background-color: #005fa3;\r\n}\r\n.message {\r\n  text-align: center;\r\n  color: #c00;\r\n  margin: 10px 0;\r\n}\r\n.resultsSection {\r\n  margin-bottom: 20px;\r\n}\r\n.noResults {\r\n  text-align: center;\r\n  color: #666;\r\n}\r\n.grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n  gap: 15px;\r\n}\r\n.card {\r\n  background: white;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n  cursor: pointer;\r\n  transition: transform 0.1s;\r\n}\r\n.card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n.serial {\r\n  font-weight: bold;\r\n  margin-bottom: 6px;\r\n}\r\n.barcode {\r\n  display: block;\r\n  margin: 0 auto 6px;\r\n  width: 100%;\r\n}\r\n.info {\r\n  font-size: 14px;\r\n  text-align: center;\r\n}\r\n.pagination {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n.pageButton {\r\n  padding: 6px 12px;\r\n  background: #007acc;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.pageButton:disabled {\r\n  background: #aaccea;\r\n  cursor: default;\r\n}\r\n.pageInfo {\r\n  font-size: 14px;\r\n}\r\n.backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0,0,0,0.4);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n.modal {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  max-width: 80%;\r\n}\r\n.pre {\r\n  background: #f4f4f4;\r\n  padding: 10px;\r\n  border-radius: 4px;\r\n  max-height: 300px;\r\n  overflow: auto;\r\n}\r\n\r\n.buttonSecondary {\r\n  padding: 6px 12px;\r\n  background: #eee;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n.buttonSecondary:hover {\r\n  background: #ddd;\r\n}\r\n.fieldGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n.label {\r\n  min-width: 80px;\r\n}\r\n.fileInput {\r\n  flex: 1;\r\n  padding: 6px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* правим позиционирование бейджа внутри карточки */\r\n.routeListBadge {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  background: #007bff;\r\n  color: #fff;\r\n  font-size: 0.75rem;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n}\r\n.card {\r\n  position: relative; /* чтобы absolute внутри работал */\r\n  /* ... остальные стили ... */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UploadAndSearchMarks_container__9Hus9`,
	"title": `UploadAndSearchMarks_title__KqudK`,
	"section": `UploadAndSearchMarks_section__ap05U`,
	"subtitle": `UploadAndSearchMarks_subtitle__YNqcy`,
	"fileInput": `UploadAndSearchMarks_fileInput__LKf7w`,
	"dateInput": `UploadAndSearchMarks_dateInput__i2KTK`,
	"button": `UploadAndSearchMarks_button__KHWdg`,
	"message": `UploadAndSearchMarks_message__u1qkR`,
	"resultsSection": `UploadAndSearchMarks_resultsSection__EhMfR`,
	"noResults": `UploadAndSearchMarks_noResults__jY3YR`,
	"grid": `UploadAndSearchMarks_grid__rIWkk`,
	"card": `UploadAndSearchMarks_card__WjJhr`,
	"serial": `UploadAndSearchMarks_serial__cF69l`,
	"barcode": `UploadAndSearchMarks_barcode__SA6-V`,
	"info": `UploadAndSearchMarks_info__cfqTK`,
	"pagination": `UploadAndSearchMarks_pagination__VXQs9`,
	"pageButton": `UploadAndSearchMarks_pageButton__ZgqzJ`,
	"pageInfo": `UploadAndSearchMarks_pageInfo__AefN7`,
	"backdrop": `UploadAndSearchMarks_backdrop__oNaqo`,
	"modal": `UploadAndSearchMarks_modal__0Ozu0`,
	"pre": `UploadAndSearchMarks_pre__omEci`,
	"buttonSecondary": `UploadAndSearchMarks_buttonSecondary__K-zY-`,
	"fieldGroup": `UploadAndSearchMarks_fieldGroup__2vseD`,
	"label": `UploadAndSearchMarks_label__lNsPn`,
	"routeListBadge": `UploadAndSearchMarks_routeListBadge__cpoZB`
};
export default ___CSS_LOADER_EXPORT___;
